import { createPermission } from '@backstage/plugin-permission-common';

export const networkFoundationPermission = createPermission({
  name: 'conduit.network-foundation.page',
  attributes: { action: 'read' },
});

export const dnsRecordPermission = createPermission({
  name: 'conduit.dns-record.page',
  attributes: { action: 'read' },
});

export const gmailDelegationPermission = createPermission({
  name: 'conduit.gmail-delegation.page',
  attributes: { action: 'read' },
});

export const staticSitePermission = createPermission({
  name: 'conduit.static-site.page',
  attributes: { action: 'read' },
});

export const staticSitePromotePermission = createPermission({
  name: 'conduit.static-site-promote.page',
  attributes: { action: 'read' },
});
